<template>
  <nav class="sidebar sidebar-offcanvas" id="sidebar">
    <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center">
      <a class="navbar-brand brand-logo" :href="logoUrl">
        <img :src="languageSpecificLogo" style="width: 60%; height: 74%;" alt="logo"/>
      </a>
      <a class="navbar-brand brand-logo-mini" :href="logoUrl">
        <img :src="languageSpecificIcon" style="width: 60%; height: 74%;" alt="logo"/>
      </a>      
    </div>

    <ul class="nav nav-scrolling">

      <li class="nav-item" v-for="(item, index) in data" :key="index" v-if="item.permission">
        <a class="nav-link"
           :href="item.subMenu ? '#'+item.id : item.url"
           :data-toggle="item.subMenu ? 'collapse' : false"
           :aria-expanded="item.subMenu ? 'false' : false"
           :aria-controls="item.subMenu ? item.id : false"
           @click="handleMenuClick(item, $event)">
                    <span class="icon-wrapper" v-if="item.icon">
                        <app-icon :name="item.icon" class="menu-icon"/>
                    </span>
          <span class="menu-title">{{ item.name }}</span>
          <i v-if="item.subMenu" class="menu-arrow"/>
        </a>

        <div class="collapse" v-if="item.subMenu" :id="item.id">
          <ul class="nav flex-column sub-menu">
            <li class="nav-item"
                v-for="(submenuItem, index) in item.subMenu"
                :key="index"
                v-if="submenuItem.permission === true || submenuItem.permission === ''">
              <a class="nav-link" :class="{'has-icon': submenuItem.icon}" :href="submenuItem.url">
                <span class="icon-wrapper" v-if="submenuItem.icon">
                  <app-icon :name="submenuItem.icon" class="menu-icon"/>
                </span>
                <span class="menu-title">{{ submenuItem.name }}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </nav>
</template>

<script>
import AppFunction from "../../helpers/app/AppFunction";

export default {
  name: "Sidebar",
  props: {
    data: {
      type: Array,
      required: true
    },
    logoSrc: {
      type: String,
      default: AppFunction.getAppUrl('images/core.png'),
    },
    logoIconSrc: {
      type: String,
      default: AppFunction.getAppUrl('images/core.png'),
    },
    logoUrl: {
      type: String,
      default: '/vendor/dashboard'
    }
  },
  computed: {
    languageSpecificLogo() {
      const currentLocale = this.$i18n.locale();
      
      // Use different logos based on language
      if (currentLocale === 'ar') {
        return '/images/rawafed-ar-noslogan.png';
      } else {
        return '/images/rawafed-en-noslogan.png';
      }
    },
    languageSpecificIcon() {
      // Use the same icon for both languages (icon files don't exist per language)
      // Check if logoIconSrc is a valid image URL (contains image extension)
      if (this.logoIconSrc && (
        this.logoIconSrc.includes('.png') || 
        this.logoIconSrc.includes('.jpg') || 
        this.logoIconSrc.includes('.jpeg') || 
        this.logoIconSrc.includes('.svg') || 
        this.logoIconSrc.includes('.gif')
      )) {
        return this.logoIconSrc;
      }
      // Fallback to the generic icon.png
      return '/images/icon.png';
    }
  },
  methods: {
    handleMenuClick(item, event) {
      // Check if this is a logout link (URL contains 'logout')
      if (item.url && item.url.includes('logout')) {
        event.preventDefault();
        this.handleLogout(item.url);
        return false;
      }
      // For items with submenus, let the default collapse behavior work (don't prevent default)
      // For regular navigation items, allow default link behavior
      // Return true to allow default behavior
    },
    handleLogout(logoutUrl) {
      // Create a form and submit it via POST
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = logoutUrl;
      
      // Add CSRF token
      const csrfToken = document.querySelector('meta[name="csrf-token"]');
      if (csrfToken) {
        const csrfInput = document.createElement('input');
        csrfInput.type = 'hidden';
        csrfInput.name = '_token';
        csrfInput.value = csrfToken.getAttribute('content');
        form.appendChild(csrfInput);
      }
      
      // Append form to body and submit
      document.body.appendChild(form);
      form.submit();
    }
  },
  mounted() {
    this.$nextTick(function () {
      let body = $('body'),
          current = location.pathname,
          sidebar = $('.sidebar'),
          sidebarType = localStorage.getItem('sidebar');

      $(function () {
        // Add active class to nav-link based on url dynamically
        function addActiveClass(element) {
          if (element.attr('href').indexOf(current) !== -1) {
            element.parents('.nav-item').last().addClass('active');
            if (sidebarType === 'floating') {
              if (element.parents('.sub-menu').length) {
                element.closest('.collapse').removeClass('show');
                element.addClass('active');
              }
              if (element.parents('.submenu-item').length) {
                element.addClass('active');
              }
            } else {
              if (element.parents('.sub-menu').length) {
                element.closest('.collapse').addClass('show');
                element.addClass('active');
              }
              if (element.parents('.submenu-item').length) {
                element.addClass('active');
              }
            }
          }
        }

        $('.nav li a', sidebar).each(function () {
          let $this = $(this);
          addActiveClass($this);
        });

        $('.horizontal-menu .nav li a').each(function () {
          let $this = $(this);
          addActiveClass($this);
        });

        // Close other submenu in sidebar on opening any
        sidebar.on('show.bs.collapse', '.collapse', function () {
          sidebar.find('.collapse.show').collapse('hide');
        });

        // Change sidebar and content-wrapper height
        applyStyles();

        function applyStyles() {
          //Applying perfect scrollbar
          if (!body.hasClass("rtl")) {
            if (body.hasClass("sidebar-fixed")) {
              let fixedSidebarScroll = new PerfectScrollbar('#sidebar .nav');
            }
          }
        }
      });

      // Sidebar collapse menu on hover
      $(document).on('mouseenter mouseleave click', '.sidebar .nav-item', function (ev) {
        let body = $('body');
        let sidebarIconOnly = body.hasClass("sidebar-icon-only");
        let sidebarFixed = body.hasClass("sidebar-fixed");
        if (sidebarIconOnly) {
          if (sidebarFixed) {
            if (ev.type === 'mouseenter') {
              body.removeClass('sidebar-icon-only');
            }
          } else {
            let $menuItem = $(this);
            if (ev.type === 'mouseenter') {
              $menuItem.addClass('hover-open')
            } else if (ev.type === 'click') {
              $menuItem.addClass('hover-open')
            } else {
              $menuItem.removeClass('hover-open')
            }
          }
        }
      });

      // Close collapse menu when mouse leave from sidebar hover only
      $(document).on('mouseenter mouseleave', '.sidebar-hover-only .sidebar', function (ev) {
        if (ev.type === 'mouseleave') {
          $('.sidebar').find('.collapse.show').collapse('hide');
        } else {

        }
      });
    });
  }
}
</script>
